import { get } from 'lib/httpClient';
import { fetchWithCache } from 'lib/apiCache';

const MENU_CACHE_KEY = '/menu/retrieve';

const retrieve_menu = async (
  callback: ((data: any) => void) | null = null,
  options: { forceRefresh?: boolean } = {}
): Promise<any> => {
  const { forceRefresh = false } = options;
  const path = MENU_CACHE_KEY;
  const result = await fetchWithCache(path, () => get(path), forceRefresh);
  console.debug('retrieve_menu', result);
  if (callback !== null) {
    callback(result?.data);
  } else return result?.data;
};

export { retrieve_menu };
